import React from "react";
import styled from "styled-components";
import { Link } from "react-router";

interface LoginSignUpToggleProps {
  link: string;
  message: React.ReactNode;
  linkText: React.ReactNode;
}

export const LoginSignUpToggle: React.FC<LoginSignUpToggleProps> = props => {
  return (
    <Container>
      {props.message}
      &nbsp;
      <StyledLink to={props.link}>{props.linkText}</StyledLink>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #fff;
  width: 100%;
  padding: 17px;
`;

const StyledLink = styled(Link)`
  color: #6777FF;
`;
